import { Component, Input, OnInit } from '@angular/core';
import { Logevent } from '../logevent/logevent';

@Component({
  selector: 'app-logeventlistview',
  templateUrl: './logeventlistview.component.html',
  styleUrls: ['./logeventlistview.component.css', '../app.component.less']
})
export class LogeventlistviewComponent implements OnInit {

  @Input() History : Logevent[]; 
  @Input() _Table : boolean;
  constructor() { }
  ngOnInit(): void {
  }
}
